import { createContext } from "react";

export type HomeBannersContextValue = {
  practiceExamStatus: ExamPracticeExamStatusVM;
};

export const HomeBannerContext = createContext<HomeBannersContextValue>({
  practiceExamStatus: {
    isSubscribed: false,
    startDate: null,
    endDate: null,
    title: null,
    positionInGroup: null,
    groupSize: null,
  },
});
